export const VEHICLE = 1
export const FREIGHT = 2
export const MY_VEHICLE = 3
export const MY_FREIGHT = 4
export const RELOADS = 5
